import { CommApiInstance} from "Utils/CommApiInstance";




const MembNrmlLoginApi = async (
    loginId:string      ,
    passwd:string       ,
    cptchTkn:string
) => {
    return await CommApiInstance.post(`athn/login`,{
        apiBody: {
            loginId:loginId,
            passwd:passwd,
            cptchTkn:cptchTkn
        }
    }).then((Resp) => Resp.data);
}
export default MembNrmlLoginApi;